// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-list-item--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 4px; }\n  .news-list-item--layout .news-list-item--clock-container {\n    display: flex;\n    align-items: center;\n    gap: 10px; }\n", ""]);
// Exports
module.exports = exports;
